import { LANDSCAPE_COMPILED_CONFIG, PORTRAIT_COMPILED_CONFIG, SQUARE_COMPILED_CONFIG } from '@goldcast/utils';
import { CompiledConfig } from '../../MainPlayer/utils/speakerLayoutGenerator/types';
import { SizeType } from '@/domains/asset';

export const layoutConfigMap: Record<SizeType, CompiledConfig> = {
  LANDSCAPE: LANDSCAPE_COMPILED_CONFIG,
  PORTRAIT: PORTRAIT_COMPILED_CONFIG,
  SQUARE: SQUARE_COMPILED_CONFIG
};
